/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrshortpng3Inputs */

const en_checkinqrshortpng3 = /** @type {(inputs: Checkinqrshortpng3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

const de_checkinqrshortpng3 = /** @type {(inputs: Checkinqrshortpng3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG`)
};

/**
* | output |
* | --- |
* | "PNG" |
*
* @param {Checkinqrshortpng3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrshortpng3 = /** @type {((inputs?: Checkinqrshortpng3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrshortpng3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrshortpng3(inputs)
	return de_checkinqrshortpng3(inputs)
});
export { checkinqrshortpng3 as "checkinQrShortPng" }